import { FC } from 'react'
import { Box, Paper, Typography, useTheme } from '@mui/material'

import { useUiActionsByResource } from 'hooks'
import { Skeleton } from '@mui/material'
import { useHistory } from 'react-router'
import { useQuery } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { handleRenderWorkflow } from 'utils'

const smallScreenWidth = 960

export const ApplicationActions: FC<any> = ({ data }) => {
    const theme = useTheme()
    const { t } = useTranslation()
    const NOUN = 'ITShopMS'
    const VERB = data.isAzureApplication ? 'AzureApps' : 'Apps'

    const { data: applicationActions, isInitialLoading } =
        useUiActionsByResource(data.id, NOUN, VERB)
    const query = useQuery()
    const history = useHistory()

    const handleActionClick = (item: any) => {
        handleRenderWorkflow(
            [`SelectedResourceID=${data.resourceID}`],
            item.requestWorkflowName,
            history,
        )
    }
    return (
        <Paper
            sx={{
                position: 'relative',
                padding: theme.spacing(2),
                display: 'flex',
                justifyContent: 'space-between',
                background: '#fbfbfd',
                boxShadow: 'none !important',

                [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                    flexDirection: 'column',
                },
            }}
            data-ai-explain="Application actions: tiles launch configured workflows for this application (for example self-service tasks)."
        >
            {isInitialLoading ? (
                <Box
                    style={{ display: 'block', width: '100%' }}
                    paddingRight={4}
                >
                    <Skeleton height={40} />
                </Box>
            ) : (
                <Box
                    sx={{
                        padding: '0 20px',
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                    }}
                >
                    {applicationActions && applicationActions.length > 0 ? (
                        applicationActions.map((item: any, index: number) => (
                            <Paper
                                key={`action-item-${index}`}
                                sx={{
                                    marginRight: '25px',
                                    width: '160px',
                                    padding: '4px 8px',
                                    fontSize: '11px',
                                    color: theme?.palette?.primary?.main,
                                    boxShadow:
                                        '0 1px 4px 0 rgba(0, 0, 0, 0.05) !important',
                                    textTransform: 'capitalize',
                                    marginBottom: '20px',
                                    border: `1px solid ${theme?.palette?.common?.white}`,
                                    '&:hover': {
                                        cursor: 'pointer',
                                    },
                                }}
                                onClick={() => handleActionClick(item)}
                            >
                                {item.friendlyName}
                            </Paper>
                        ))
                    ) : (
                        <Typography>{t('NoActionFound')}</Typography>
                    )}
                </Box>
            )}
        </Paper>
    )
}
